import { getMockOrder, ModelPosition, Order, TextPosition } from '@acies/domain';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-orderconfiguration-component',
	templateUrl: './orderconfiguration.component.html',
	styleUrls: ['./orderconfiguration.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class OrderConfigurationComponent implements OnInit {
	private route: ActivatedRoute;
	public order: Order | null;
	public orderDate: string;
	public positions: (ModelPosition | TextPosition)[];

	public constructor(route: ActivatedRoute) {
		this.route = route;
	}

	public ngOnInit(): void {
		this.order = getMockOrder();
		this.orderDate = this.order.orderDate.toLocaleDateString('da-DK', {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
		});
		this.positions = this.order.positions;
	}
}
